import { PROMO_CODE_TYPES } from '../../../constants';
import { TICKET_SOLD_OUT } from '../constants';

export const shouldShowPromoCodePills = ({
    amountOff,
    discountType,
    onSaleStatus,
}: {
    amountOff?: { currency: string; display: string; value: number };
    discountType?: typeof PROMO_CODE_TYPES[keyof typeof PROMO_CODE_TYPES];
    onSaleStatus: string;
}) => ({
    showDiscountedPill:
        onSaleStatus !== TICKET_SOLD_OUT && !!discountType && !!amountOff,
    showUnlockedPill: discountType === PROMO_CODE_TYPES.ACCESS,
});
